import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=45c6e0fe&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c6e0fe')) {
      api.createRecord('45c6e0fe', component.options)
    } else {
      api.reload('45c6e0fe', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=45c6e0fe&", function () {
      api.rerender('45c6e0fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G1J2YncAYtzc/JS/offershelp.vue"
export default component.exports